/**
 * @file
 * Enhanced modal functionality for Constitution Day theme.
 */

(function ($, Drupal, once) {
  'use strict';

  /**
   * Behavior for enhanced modal functionality.
   */
  Drupal.behaviors.constdayModals = {
    attach: function (context, settings) {
      // Initialize enhanced modals
      once('constday-modals', '.modal', context).forEach(function (modal) {
        initModal(modal);
      });

      // Initialize modal triggers
      once('constday-modal-triggers', '[data-bs-toggle="modal"]', context).forEach(function (trigger) {
        initModalTrigger(trigger);
      });

      // Initialize search modal functionality
      once('constday-search-modal', '.modal-search', context).forEach(function (searchModal) {
        initSearchModal(searchModal);
      });
    }
  };

  /**
   * Initialize enhanced modal functionality.
   *
   * @param {HTMLElement} modal
   *   The modal element.
   */
  function initModal(modal) {
    const $modal = $(modal);
    const bsModal = bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal);

    // Store last active element to restore focus when modal closes
    let lastActiveElement = null;

    // Focus management
    $modal.on('shown.bs.modal', function () {
      // Store the element that had focus before opening the modal
      lastActiveElement = document.activeElement;

      // Focus the first focusable element in the modal
      const focusableElements = $modal.find('a[href], button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])').filter(':visible');

      if (focusableElements.length) {
        focusableElements.first().focus();
      } else {
        // If no focusable elements, focus the modal itself
        $modal.attr('tabindex', '-1').focus();
      }
    });

    // Restore focus when modal closes
    $modal.on('hidden.bs.modal', function () {
      if (lastActiveElement) {
        lastActiveElement.focus();
      }
    });

    // Trap focus within modal
    $modal.on('keydown', function (e) {
      // If not tab key, return
      if (e.key !== 'Tab') {
        return;
      }

      const focusableElements = $modal.find('a[href], button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])').filter(':visible');

      if (focusableElements.length === 0) {
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      // If shift+tab and first element is focused, move to last focusable element
      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
      // If tab and last element is focused, move to first focusable element
      else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    });

    // Add custom animation class based on modal type
    if ($modal.hasClass('modal-resource-preview')) {
      $modal.addClass('modal-animation-slide-up');
    } else if ($modal.hasClass('modal-confirmation')) {
      $modal.addClass('modal-animation-zoom');
    }
  }

  /**
   * Initialize modal trigger functionality.
   *
   * @param {HTMLElement} trigger
   *   The trigger element.
   */
  function initModalTrigger(trigger) {
    const $trigger = $(trigger);
    
    // Add ARIA attributes for accessibility
    if (!$trigger.attr('aria-haspopup')) {
      $trigger.attr('aria-haspopup', 'dialog');
    }
    
    // Get target modal ID
    const targetId = $trigger.attr('data-bs-target') || $trigger.attr('href');
    if (targetId && targetId.startsWith('#')) {
      const modalId = targetId.substring(1);
      $trigger.attr('aria-controls', modalId);
    }
  }

  /**
   * Initialize search modal functionality.
   *
   * @param {HTMLElement} searchModal
   *   The search modal element.
   */
  function initSearchModal(searchModal) {
    const $searchModal = $(searchModal);
    const $searchInput = $searchModal.find('[data-search-input]');
    const $searchResults = $searchModal.find('[data-search-results]');
    
    // Focus search input when modal opens
    $searchModal.on('shown.bs.modal', function () {
      $searchInput.focus();
    });
    
    // Clear search input when modal closes
    $searchModal.on('hidden.bs.modal', function () {
      $searchInput.val('');
      $searchResults.empty();
    });
    
    // Handle search input
    let searchTimeout;
    $searchInput.on('input', function () {
      const query = $(this).val().trim();
      
      // Clear previous timeout
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
      
      // If query is empty, clear results
      if (query === '') {
        $searchResults.empty();
        return;
      }
      
      // Debounce search to avoid excessive requests
      searchTimeout = setTimeout(function () {
        // Simulate search results (replace with actual search implementation)
        simulateSearch(query, $searchResults);
      }, 300);
    });
  }
  
  /**
   * Simulate search results (placeholder for actual search implementation).
   *
   * @param {string} query
   *   The search query.
   * @param {jQuery} $resultsContainer
   *   The results container element.
   */
  function simulateSearch(query, $resultsContainer) {
    // This is a placeholder. In a real implementation, you would:
    // 1. Make an AJAX request to a search endpoint
    // 2. Process the results
    // 3. Render the results in the container
    
    // For now, we'll just show a message
    $resultsContainer.html('<div class="p-4 text-center text-muted">Search functionality will be implemented in a future update.</div>');
  }

})(jQuery, Drupal, once);